import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";

export default function Addcareer() {
  const navigate = useNavigate();

  const { state } = useLocation();

  const [formData, setFormData] = useState({
    title: "",
    experience: "",
    gender: "",
    location: "",
    last_date: "",
    content: "",
  });

  const [image, setImage] = useState(null);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const addJob = (event) => {
    event.preventDefault();

    const reqbody = new FormData();

    reqbody.append("store", localStorage.getItem("store_id"));
    reqbody.append("Title", formData.title);
    reqbody.append("Experience", formData.experience);
    reqbody.append("Gender", formData.gender);
    reqbody.append("Location", formData.location);
    reqbody.append("last_date", formData.last_date);
    reqbody.append("Content", formData.content);

    if (image) {
      reqbody.append("images", image);
    }

    axios
      .post(
        "https://m1blog.aaragroups.com/blog/api/admin/api/job-list-api/",
        reqbody,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((response) => {
        toast.success(response.data.message);
        navigate("/career");
      })
      .catch((error) => {
        console.error("Error adding job:", error);
        toast.error("Something went wrong");
      });
  };

  const UpdateCarrer = (event) => {
    event.preventDefault();
    const reqbody = new FormData();
    reqbody.append("store", localStorage.getItem("store_id"));
    reqbody.append("Title", formData.title);
    reqbody.append("Experience", formData.experience);
    reqbody.append("Gender", formData.gender);
    reqbody.append("Location", formData.location);
    reqbody.append("last_date", formData.last_date);
    reqbody.append("Content", formData.content);

    if (image) {
      reqbody.append("images", image);
    }

    axios
      .put(
        `https://m1blog.aaragroups.com/blog/api/admin/api/job-deatils-api/?id=${state}`,
        reqbody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((response) => {
        toast.success(response.data.message);
        navigate("/career");
      })
      .catch((error) => {
        console.error("Error adding blog:", error);
      });
  };

  const getNews = () => {
    axios
      .get(
        "https://m1blog.aaragroups.com/blog/store-based-jobs-list-api/",

        {
          params: {
            job_id: state,
          },
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        console.log(res, "sagdjsgduj");

        handleEdit(res.data?.news_details);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err.response.data.message);
      });
  };

  useEffect(() => {
    if (state) getNews();
  }, [state]);

  const handleEdit = (prev) => {
    console.log(prev, "data state");
    if (prev) {
      setFormData({
        title: prev?.Title || "",
        experience: prev?.Experience || "",
        gender: prev?.Gender || "",
        location: prev?.Location || "",
        last_date: prev?.last_date || "",
        content: prev?.Content || "",
      });
    }
  };

  return (
    <div className="flex justify-center py-6">
      <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-6">Add Career</h2>

        <form
          onSubmit={state ? UpdateCarrer : addJob}
          className="flex flex-col gap-5"
        >
          {/* Title */}
          <div>
            <p className="text-sm font-semibold mb-1">Title</p>
            <input
              className="w-full border rounded p-2"
              value={formData.title}
              onChange={(e) => handleChange("title", e.target.value)}
              required
            />
          </div>

          {/* Experience */}
          <div>
            <p className="text-sm font-semibold mb-1">Experience (In Year)</p>
            <input
              type="number"
              className="w-full border rounded p-2"
              value={formData.experience}
              onChange={(e) => handleChange("experience", e.target.value)}
              required
            />
          </div>

          {/* Gender */}
          <div>
            <p className="text-sm font-semibold mb-1">Gender</p>
            <select
              className="w-full border rounded p-2"
              value={formData.gender}
              onChange={(e) => handleChange("gender", e.target.value)}
              required
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Both">Both</option>
            </select>
          </div>

          {/* Location */}
          <div>
            <p className="text-sm font-semibold mb-1">Location</p>
            <input
              className="w-full border rounded p-2"
              value={formData.location}
              onChange={(e) => handleChange("location", e.target.value)}
              required
            />
          </div>

          {/* Last Date */}
          <div>
            <p className="text-sm font-semibold mb-1">Last Date</p>
            <input
              type="date"
              className="w-full border rounded p-2"
              value={formData.last_date}
              onChange={(e) => handleChange("last_date", e.target.value)}
              required
            />
          </div>

          {/* Image */}
          <div>
            <p className="text-sm font-semibold mb-1">Image</p>
            <ImagePicker placeholder="Upload Image" handleChange={setImage} />
          </div>

          {/* Content */}
          <div>
            <p className="text-sm font-semibold mb-1">Content</p>
            <ReactQuill
              value={formData.content}
              onChange={(value) => handleChange("content", value)}
              className="bg-white"
            />
          </div>

          {/* Submit */}
          <Button type="submit" variant="contained">
            {state ? "Update" : "Add"} Job
          </Button>
        </form>
      </div>
    </div>
  );
}
